import React, { useState } from "react";
import StaffListWeb from "./StaffListWeb";
import AddIcon from "../../assets/plus-icon.svg";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

function StaffWebView({
  staffList,
  setDrawerOpen,
  staffEdit,
  staffDelete,
  currentPage,
  getstaffList,
}) {
  let doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  return (
    <>
      <div className="row">
        <div className="col-lg-11 col-md-11">
          <span className="staff-details">
            {" "}
            {doctorClinicAssociation === "true"
              ? "Clinic Staff Details"
              : "Staff Details"}
          </span>{" "}
          <span className="staff-members">
            (You can add upto 100 support staff members)
          </span>
        </div>
        {/* {staffList?.length < 100 ? ( */}
        <div
          className={`col-lg-1 col-md-1 add-btn ${
            getstaffList?.length < 100 ? "" : "staff_addBtn_disabled"
          }`}
          onClick={() => setDrawerOpen()}
        >
          {getstaffList?.length < 100 ? (
            <img src={AddIcon} height="20px" width="20px" alt="addIcon" />
          ) : (
            <i className={"fa fa-plus-circle fa-lg mr-1"} />
          )}
          Add
        </div>
        {/* ) : (
          ""
        )} */}
      </div>
      {staffList.length ? (
        <StaffListWeb
          staffList={staffList}
          staffEdit={staffEdit}
          staffDelete={staffDelete}
          currentPage={currentPage}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default StaffWebView;
